			/**
			 * @ngdoc service
			 * @name WcResponsiveTableModule.service:WcTableScopeService
			 * @description
			 * The WcTableScopeService is responsible for maintain the scope of the table, the service holds the methods
			 * that are related to table scope.
			 */



angular.module('WcResponsiveTableModule')
	.factory('WcTableScopeService', function() {
		function WcTableScopeService() {

            this.parentScope = null;
            this.tableScope = null;
        }


		WcTableScopeService.prototype = {
            /**
             * @ngdoc method
             * @name getParentScope
             * @methodOf WcResponsiveTableModule.service:WcTableScopeService
             * @returns {string} This string holds parent scope value.
             * @description
             * The method is to get the parent scope value
             */

            getParentScope: function () {
                return this.parentScope;
            },

            /**
             * @ngdoc method
             * @name getTableScope
             * @methodOf WcResponsiveTableModule.service:WcTableScopeService
             * @returns {string} This string holds table scope value.
             * @description
             * The method is to get the table scope value
             */

            getTableScope: function () {
                return this.tableScope;
            },

            /**
             * @ngdoc method
             * @name setParentScope
             * @methodOf WcResponsiveTableModule.service:WcTableScopeService
             * @param {string} newParentScope This string value holds the new parent scope
             * @description
             * The method is to set the parent scope value
             */

            setParentScope: function (newParentScope) {
                if (newParentScope.$id !== 0 && !newParentScope.$id) {
                    this.parentScope = null;
                    console.error('WcTableScopeService: setTableScope(); You must pass in a valid Angular Scope');
                } else if (this.tableScope && newParentScope.$id === this.tableScope.$id) {
                    this.parentScope = null;
                    console.error('WcTableScopeService: setTableScope(); parent scope and table scope can not be the same scope');
                } else {
                    this.parentScope = newParentScope;
                }
            },

            /**
             * @ngdoc method
             * @name setTableScope
             * @methodOf WcResponsiveTableModule.service:WcTableScopeService
             * @param {string} newTableScope This string value holds the new table scope
             * @description
             * The method is to set the table scope value
             */

            setTableScope: function (newTableScope) {
                if (newTableScope.$id !== 0 && !newTableScope.$id) {
                    this.tableScope = null;
                    console.error('WcTableScopeService: setTableScope(); You must pass in a valid Angular Scope');
                } else if (this.parentScope && newTableScope.$id === this.parentScope.$id) {
                    this.tableScope = null;
                    console.error('WcTableScopeService: setTableScope(); parent scope and table scope can not be the same scope');
                } else {
                    this.tableScope = newTableScope;
                }
            }
        };

		return WcTableScopeService;
	}

);